import { baseRestApi } from "api/rest/baseRestApi";

import { Shipper } from "./types";

type QueryArgs = { body: { name?: string; booking_terms_and_conditions?: string } };

type ResponseType = { data: { shipper: Shipper } };

module.hot?.accept();

export const updateShipperApi = baseRestApi.enhanceEndpoints({ addTagTypes: ["SHIPPERS"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    updateShipper: builder.mutation<ResponseType, QueryArgs>({
      query: ({ body }) => ({
        method: "PUT",
        url: `shipper/shippers`,
        body,
      }),
      invalidatesTags: ["SHIPPERS"],
    }),
  }),
});

export const { useUpdateShipperMutation } = updateShipperApi;

export default updateShipperApi;
